import { FormField, Input } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

import { type BankInfosErrors, type SupplierBankInfos } from '../../../models';

type Props = {
  className?: string;
  isOptional?: boolean;
  accountNumber: SupplierBankInfos['accountNumber'];
  error?: BankInfosErrors['accountNumber'];
  onChange(accountNumber: SupplierBankInfos['accountNumber']): void;
};

export const AccountNumberFormField = ({
  className,
  isOptional,
  accountNumber,
  error,
  onChange,
}: Props) => {
  const { t } = useTranslation('global');

  const getMessageFromError = (
    rawError: BankInfosErrors['accountNumber'],
  ): string => {
    switch (rawError) {
      case 'invalid': {
        return t('submitMyInvoice.fields.accountNumber.error');
      }
      default:
        return t('misc.requiredField');
    }
  };

  return (
    <FormField
      className={className}
      label={t('submitMyInvoice.fields.accountNumber.label')}
      alertMessage={error ? getMessageFromError(error) : undefined}
      hint={isOptional ? t('misc.optional') : undefined}
    >
      <Input
        name="accountNumber"
        value={accountNumber ?? ''}
        placeholder={t('submitMyInvoice.fields.accountNumber.placeholder')}
        pattern="\d{0,20}"
        onChange={(event) => {
          if (event.target.checkValidity()) {
            onChange(event.target.value);
          }
        }}
        data-mask
      />
    </FormField>
  );
};
